<template>
	<div style="background-color:#F0F0F0;">

        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Advanced Settings</v-toolbar-title>
        </v-toolbar>

        <div class="hasToolbar full-height">
            
            <v-list nopadding>

                <v-list-tile to="/settings/business/transactionnew" v-ripple>
                    <v-list-tile-content>
                        <v-list-tile-title>Transaction Settings</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/transaction" v-ripple>
                    <v-list-tile-content>
                        <v-list-tile-title>Transaction Forms</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_openFields" v-ripple>
                    <v-list-tile-content>
                        <v-list-tile-title>Transaction Fields</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/numberseries/items" v-ripple>
                    <v-list-tile-content>
                      <v-list-tile-title>Number Series</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/printtemplate/items" v-ripple>
                    <v-list-tile-content>
                      <v-list-tile-title>Print Templates</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_goToPrintFields(true)">
                    <v-list-tile-content>
                      <v-list-tile-title>Print Fields</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

            </v-list>

        </div>

	</div>
</template>

<script>

    export default{

        // data(){
        //     return{

        //     }
        // },

        methods:{
            fn_goBack: function(){
                this.$router.go(-1);
            },

            fn_openFields: function(){
                this.$router.push({name:'fieldItems', query:{tagId:this.guidWeb()}, params: { 'isNew': 1 }});
            },

            fn_goToPrintFields: function(){
                this.$router.push({path:"/printfield/items", query:{new:1}});
            },
        },

        mounted: function(){
            window.js_globals.fn_onBackPress = this.fn_goBack;
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/settings/configurations/configurations.vue